
export function dateRange(from = null, to = null, utc = false) {
  if (from && to) {
    return fromDateTime(from, utc) + '--' + toDateTime(to, utc);
  } else if (from) {
    return fromDateTime(from, utc) + '--';
  } else if (to) {
    return '--' + toDateTime(to, utc);
  }
}

function fromDateTime(from: any, utc: boolean) {
  const date = new Date(from);
  if (utc) {
    date.setUTCHours(0, 0, 0, 0);
  } else {
    date.setHours(0, 0, 0, 0);
  }
  return date.toISOString();
}

function toDateTime(to: any, utc: boolean) {
  const date = new Date(to);
  if (utc) {
    date.setUTCHours(23, 59, 59, 999);
  } else {
    date.setHours(23, 59, 59, 999);
  }
  return date.toISOString();
}
